import { BaseCurrencyInput, Hairline, Radio } from "@components";
import { TimeInput } from "@components/TimeInput";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/creative.module.scss";

export const SpendReminder = ({ coupon, onChangeCreative }) => {
  const [spendReminder, setSpendReminder] = useState(
    coupon?.expiration?.spend?.remind?.active
  );

  useEffect(() => {
    onChangeCreative &&
      onChangeCreative({
        ...(coupon?.expiration?.spend?.remind || {}),
        active: spendReminder,
      });
  }, [spendReminder]);

  return (
    <>
      <p className={styles.label}>
        Deseja ativar lembrete de expiração de gasto?
      </p>
      <Radio
        family="spend-reminder"
        className="mb-10"
        value={true}
        checked={spendReminder}
        onChange={() => setSpendReminder(true)}
      >
        Sim
      </Radio>
      <Radio
        family="spend-reminder"
        value={false}
        checked={spendReminder}
        onChange={() => setSpendReminder(false)}
      >
        Não
      </Radio>

      {spendReminder && (
        <div className={styles.reminderBox}>
          <p className={styles.label}>
            Defina o período para lembrete de expiração
          </p>
          <BaseCurrencyInput
            placeholder="--- dias antes da expiração"
            prefix={""}
            precision={0}
            suffix={" dias antes da expiração"}
            value={coupon?.expiration?.spend?.remind?.days}
            onChange={(days) => {
              onChangeCreative &&
                onChangeCreative({
                  ...(coupon?.expiration?.spend?.remind || {}),
                  days: days,
                });
            }}
          />

          <Hairline solid className="mt-20 mb-20" />

          <p className={styles.label}>Determine a hora do envio</p>
          <TimeInput
            center
            value={coupon?.expiration?.spend?.remind?.time}
            onChange={(time) => {
              onChangeCreative &&
                onChangeCreative({
                  ...(coupon?.expiration?.spend?.remind || {}),
                  time,
                });
            }}
          />
        </div>
      )}
    </>
  );
};
